import { useI18n } from "@baton/i18n";
import { CircleHelp, Keyboard, Link2 } from "@baton/icons";
import { DropdownMenu } from "@baton/ui";
import { useNavigate } from "react-router";
import { useMenuOpensDialog } from "../../app/menuOpensDialog.ts";

/**
 * `contracts/screens.md` § The rail and the work surface: the rail's Help tile, which opens a menu
 * (2026-09-30, from the meeting of 2026-09-29, Mejd: "MCP download location unclear: currently buried
 * under profile, not intuitive"): Keyboard shortcuts, the reference the tile opened on its own until
 * then, and Connect AI tools, the Team settings page with the MCP server (`/{ws}/settings/connect-ai`).
 * The menu opens to the tile's right, as the account card beside it does; the shortcut reference is a
 * dialog, so its row keeps the focus where the dialog puts it (`useMenuOpensDialog`).
 */
export function HelpMenu({ ws, onShortcuts }: { readonly ws: string; readonly onShortcuts: () => void }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { opens, onCloseAutoFocus } = useMenuOpensDialog();
  return (
    <DropdownMenu
      label={t("nav.help")}
      side="right"
      align="end"
      onCloseAutoFocus={onCloseAutoFocus}
      items={[
        { id: "shortcuts", label: t("nav.help.shortcuts"), icon: <Keyboard />, shortcut: "?", onSelect: opens(onShortcuts) },
        { id: "connect-ai", label: t("nav.settings.connectAi"), icon: <Link2 />, onSelect: () => void navigate(`/${ws}/settings/connect-ai`) },
      ]}
      trigger={
        <button type="button" className="b-rail__item" data-glide-row>
          <CircleHelp aria-hidden="true" />
          <span className="b-rail__label">{t("nav.help")}</span>
        </button>
      }
    />
  );
}
